<script lang="ts">
	import type { Snippet } from 'svelte';
	import type { ClassValue } from 'svelte/elements';

	interface Props {
		children?: Snippet;
		class?: ClassValue;
		dataTestId?: string;
	}

	const {
		children,
		class: classes,
		dataTestId,
	}: Props = $props();
</script>

<div
	class={['card px-1 pt-4.25 pb-1 border-neutral-soft border-solid border-1 shadow-smooth-bottom-2  bg-neutral-weakest rounded-xl', classes]}
	data-testid={dataTestId}
>
	{@render children?.()}
</div>
